export default "__VITE_ASSET__2dee7790__"